import * as fromDatatype from '../datatype-library/index';

export interface bl_msg_label_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_label_hdr: fromDatatype.GuidDataFieldInterface;
  guid_msgbox: fromDatatype.GuidDataFieldInterface;
  guid_message_hdr: fromDatatype.GuidDataFieldInterface;
  guid_message_line: fromDatatype.GuidDataFieldInterface;
  sort_sequence:fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_msg_label_link_RowClass implements bl_msg_label_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_label_hdr: fromDatatype.GuidDataFieldInterface;
  guid_msgbox: fromDatatype.GuidDataFieldInterface;
  guid_message_hdr: fromDatatype.GuidDataFieldInterface;
  guid_message_line: fromDatatype.GuidDataFieldInterface;
  sort_sequence:fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

